/* E-Ticaret — Bol modülleri (sadece çalışan/yetkili olanlar). */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    BarChart3, Wallet, Package, Settings as SettingsIcon, ShoppingBag, Users, FileText, MessageSquare, Receipt,
} from 'lucide-react';
import EcommerceTab from './sales/EcommerceTab';
import BolDashboard from './sales/BolDashboard';
import BolProfitability from './sales/BolProfitability';
import BolCustomers from './sales/BolCustomers';
import BolInvoiceRequests from './sales/BolInvoiceRequests';
import { InvoicesTab as BolCommissionInvoicesTab } from './BolHub';
import CustomerQATab from './sales/parts/CustomerQATab';
import KioskTokenCard from './sales/parts/KioskTokenCard';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../components/layout/DashboardLayout';

export default function Ecommerce() {
    const [params, setParams] = useSearchParams();
    const tab = params.get('tab') || 'dashboard';
    const [newCount, setNewCount] = useState(0);
    const API = process.env.REACT_APP_BACKEND_URL;
    const token = localStorage.getItem('token');

    // Yeni sipariş canli rozet (30sn polling)
    useEffect(() => {
        const poll = async () => {
            try {
                const r = await axios.get(`${API}/api/bol/orders?status=open&limit=1`,
                    { headers: { Authorization: `Bearer ${token}` } });
                const total = r.data?.counts?.open || 0;
                if (tab === 'orders') {
                    localStorage.setItem('bol_last_seen_count', String(total));
                    setNewCount(0);
                    return;
                }
                const lastSeen = parseInt(localStorage.getItem('bol_last_seen_count') || '0', 10);
                const diff = Math.max(0, total - lastSeen);
                setNewCount(diff);
            } catch { /* ignore */ }
        };
        poll();
        const id = setInterval(poll, 30000);
        return () => clearInterval(id);
    }, [API, token, tab]);

    const setTab = (k) => { setParams({ tab: k }); };

    const tabs = [
        { k: 'dashboard', l: 'Dashboard', icon: BarChart3 },
        { k: 'profitability', l: 'Karlılık', icon: Wallet },
        { k: 'orders', l: 'Siparişler', icon: Package, badge: newCount },
        { k: 'invoice-requests', l: 'Fatura Talepleri', icon: FileText },
        { k: 'commission-invoices', l: 'Komisyon Faturaları', icon: Receipt },
        { k: 'customers', l: 'Müşteriler', icon: Users },
        { k: 'customer-qa', l: 'Soru-Yanıt', icon: MessageSquare },
        { k: 'settings', l: 'Ayarlar', icon: SettingsIcon },
    ];

    return (
        <DashboardLayout>
            <div className="-mx-6 md:-mx-12 -my-8 md:-my-10 min-h-screen bg-gray-50" data-testid="ecom-wide-wrap">
                <div className="max-w-none px-3 md:px-6 py-3 md:py-5">
                    <div className="flex items-center gap-3 mb-4">
                        <ShoppingBag size={22} className="text-gray-700" />
                        <h1 className="text-lg md:text-xl font-bold text-gray-900">E-Ticaret</h1>
                        <span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full">Bol.com</span>
                    </div>

                    <div className="bg-white border border-gray-200 rounded-lg mb-3 overflow-x-auto" data-testid="ecom-tabs">
                        <div className="flex gap-1 p-1 min-w-max">
                            {tabs.map((t) => {
                                const Icon = t.icon;
                                const active = tab === t.k;
                                return (
                                    <button key={t.k} onClick={() => setTab(t.k)}
                                        className={`flex items-center gap-1.5 px-3 md:px-4 py-2 text-xs md:text-sm font-semibold rounded-md whitespace-nowrap transition-colors relative ${
                                            active ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'
                                        }`}
                                        data-testid={`ecom-tab-${t.k}`}>
                                        <Icon size={14} />
                                        {t.l}
                                        {t.badge > 0 && (
                                            <span className="ml-1 px-1.5 py-0.5 text-[10px] font-bold bg-rose-500 text-white rounded-full animate-pulse">
                                                {t.badge}
                                            </span>
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className="bg-white border border-gray-200 rounded-lg p-3 md:p-5">
                        {tab === 'dashboard' && <BolDashboard />}
                        {tab === 'profitability' && <BolProfitability />}
                        {tab === 'orders' && <EcommerceTab hideHeader />}
                        {tab === 'invoice-requests' && <BolInvoiceRequests />}
                        {tab === 'commission-invoices' && <BolCommissionInvoicesTab />}
                        {tab === 'customers' && <BolCustomers />}
                        {tab === 'customer-qa' && <CustomerQATab />}
                        {tab === 'settings' && (
                            <div className="space-y-4">
                                <KioskTokenCard />
                                <div className="text-sm text-gray-600">
                                    Bol.com ve Telegram ayarları için: <a href="/settings?tab=api" className="text-blue-600 underline">Ayarlar → API Bağlantıları</a>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
}
